import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-diploma',
  templateUrl: './diploma.component.html',
  styleUrls: ['./diploma.component.scss']
})
export class DiplomaComponent implements OnInit {
    cards = [
        {
            title: 'Engineering',
            subheading: 'ARNI School of Technology',
            programs: 1,
            course: 1,
            icon: 'fa fa-info-circle',
            url: '/schools/arni-school-of-technology'
        },
        {
            title: 'Management',
            subheading: 'ARNI School of Business Management & Commerce',
            programs: 1,
            course: 1,
            icon: 'fa fa-user',
            url : '/schools/arni-school-of-business-management-and-commerce'
        },
        {title: 'Pharmacy', subheading: 'ARNI School of Pharmacy', programs: 1, icon: 'fa fa-cog',
            url: '/schools/arni-school-of-pharmacy'},
        {
            title: 'Arts and Humanities',
            subheading: 'ARNI School of Arts & Humanities',
            programs: 1,
            course: 1,
            icon: 'fa fa-bell',
            url : '/schools/arni-school-of-art-and-humanities'
        },
        {
            title: 'Basic Sciences',
            subheading: 'ARNI School of Basic Sciences & Bio-Technology',
            programs: 1,
            course: 1,
            specialization: 0,
            icon: 'fa fa-star',
            url : '/schools/arni-school-of-basic-science-and-biotechnology'
        },
        {
            title: 'Pharmacy',
            subheading: 'ARNI SCHOOL OF PHARMACY AND PARAMEDICAL STUDIES',
            programs: 1,
            course: 1,
            specialization: 0,
            icon: 'fa fa-hotel',
            iconColor: 'text-orange-500',
            url: '/schools/arni-school-of-pharmacy'
        }
    ];

    constructor(private router: Router) {
    }

    ngOnInit(): void {
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

}
